import { addBreadcrumb, updateBreadcrumbs } from '@state/actions/breadcrumbsActions'
import { AppContext } from '@state/context'
import { useContext, useEffect } from 'react'

const useBreadcrumbs = (breadcrumb) => {
  const [state, dispatch] = useContext(AppContext)
  const { breadcrumbs: { newBreadcrumb, currentLocation } } = state

  useEffect(() => {
    if (newBreadcrumb && currentLocation && newBreadcrumb?.link === currentLocation?.pathname) {
      dispatch(updateBreadcrumbs())
    }
  }, [newBreadcrumb, currentLocation])

  useEffect(() => {
    if (breadcrumb?.label) {
      dispatch(addBreadcrumb({
        link: window.location.hash.replace('#', ''),
        label: breadcrumb.label
      }))
    }
  }, [breadcrumb])
}

export { useBreadcrumbs }
